/*
 * Animated link
 */
$(document).ready(function() {

    $('.h-rubberband').hover(
        function() {
            $(this).addClass('animated rubberBand');
        },
        function() {
            $(this).removeClass('animated rubberBand');
        }
    );
});

/*
 * Volume video home page
 */
$(document).ready(function() {
    $(".video-stop-volume").prop("volume", 0);
});

var code_url = function(string) {
    var words = string.split(' ');
    var min_length = 1;
    var cleaned_words = [];
    var accent = ['â', 'á', 'à', 'ä', 'ã', 'æ', 'ç', 'é', 'è', 'ê', 'ë', 'î', 'ï', 'í', 'ì', 'ñ', 'ô', 'ö', 'ó', 'ò', 'õ', 'œ', '°', 'û', 'ú', 'ù', 'ü', 'Â', 'Á', 'À', 'Ä', 'Ã', 'Æ', 'Ç', 'É', 'È', 'Ê', 'Ë', 'Î', 'Ï', 'Í', 'Ì', 'Ñ', 'Ô', 'Ö', 'Ó', 'Ò', 'Õ', 'Œ', 'Û', 'Ú', 'Ù', 'Ü'];
    var sans_accent = ['a', 'a', 'a', 'a', 'a', 'a', 'c', 'e', 'e', 'e', 'e', 'i', 'i', 'i', 'i', 'n', 'o', 'o', 'o', 'o', 'o', 'oe', 'o', 'u', 'u', 'u', 'u', 'a', 'a', 'a', 'a', 'a', 'a', 'c', 'e', 'e', 'e', 'e', 'i', 'i', 'i', 'i', 'n', 'o', 'o', 'o', 'o', 'o', 'oe', 'u', 'u', 'u', 'u'];

    for (var i = 0; i < words.length; i++) {
        var word = words[i];
        if (word.length >= min_length) {
            word = word.replace(',', '');
            word = word.replace('.', '');
            word = word.replace('…', '');
            word = word.replace('\'', '-');
            word = word.replace('‘', '');
            word = word.replace('’', '-');
            word = word.replace('\\', '');
            word = word.replace('/', '-');
            word = word.replace('|', '-');
            word = word.replace('–', '-');
            word = word.replace(':', '');
            word = word.replace(';', '');
            word = word.replace('"', '');
            word = word.replace('«', '');
            word = word.replace('»', '');
            word = word.replace('“', '');
            word = word.replace('”', '');
            word = word.replace('!', '');
            word = word.replace('?', '');
            word = word.replace('%', '');
            word = word.replace('&', '');
            word = word.replace('@', '');
            word = word.replace('®', '');
            word = word.replace('©', '');
            word = word.replace('+', '');
            word = word.replace('*', '');
            word = word.replace("( |')", "-");
            word = word.replace('(', '');
            word = word.replace(')', '');
            word = word.replace('#', '');

            word = word.replaceArray(accent, sans_accent);
            word = word.replace("/[^a-z0-9]/g", "-");
            word = word.replace("/(^(_)*|(_)*$)/g", "");
            word = word.replace("/#(-){2,3}#/g", "");
            if (word.indexOf('-') == 1) word = word.substr(1, word.length);
            //word = eregi_replace("([0-9])*","",word);
            word = word.toLowerCase();

            cleaned_words.push(word);

        }
    }
    var cleaned_string = cleaned_words.join('-');
    cleaned_string = cleaned_string.replace('---', '-');
    cleaned_string = cleaned_string.replace('--', '-');

    return cleaned_string;
};

String.prototype.replaceArray = function(find, replace) {
    var replaceString = this;
    for (var i = 0; i < find.length; i++) {
        replaceString = replaceString.replace(find[i], replace[i]);
    }
    return replaceString;
};

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}